<template>
  <div class="container">
    <note-input></note-input>
    <note-list :notes="notes" v-if="notes.length > 0"></note-list>
    <note-hint v-else v-once></note-hint>
  </div>
</template>

<script>
import { provide } from 'vue';
import { ref } from '@vue/reactivity';
import { v4 } from 'uuid';
import NoteInput from '@/components/NoteInput.vue';
import NoteList from '@/components/NoteList.vue';
import NoteHint from '@/components/NoteHint.vue';
import store from '@/store';

export default {
  name: 'Home',
  components: {
    NoteInput,
    NoteList,
    NoteHint,
  },
  setup() {
    const notes = ref(store.getAll());
    const addNote = (title, descr) => {
      const newNote = {
        id: v4(),
        title,
        descr,
      };
      store.create(newNote);
      notes.value.unshift(newNote);
    };
    const removeNote = (id) => {
      store.delete(id);
      notes.value = notes.value.filter((n) => n.id !== id);
    };
    provide('addNote', addNote);
    provide('removeNote', removeNote);

    return {
      notes,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/utils/functions';

.container {
  max-width: 480px;
  margin: 0 auto;
  padding: {
    left: rem(15);
    right: rem(15);
    top: rem(60);
  }

  // grid
  display: grid;
  grid-gap: rem(40) 0;
  grid-template-rows: repeat(1, auto);
}
</style>
